export default __webpack_public_path__ + "static/alarm-monitoring-40898953698f6ba323c3016b3a0a919e.png";